import React from 'react';
import { Link } from 'react-router-dom';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center">
      <Link to="/" className="flex items-center">
        <img
          src="/assets/logo.svg"
          alt="A.O Smith"
          className="h-16 sm:h-16 md:h-16 lg:h-20 xl:h-24"
        />
      </Link>
    </div>
  );
};

export default Logo;